unit Essentials.Web.Notes.Form;

interface

uses
  System.SysUtils,
  System.Classes,
  JS,
  Web,
  WEBLib.Graphics,
  WEBLib.Controls,
  WEBLib.Forms,
  WEBLib.Dialogs,
  WebForm.Core,
{$IFDEF PAS2JS}
  DB,
{$ELSE}
  Data.DB,
{$ENDIF}
  XData.Web.JsonDataset,
  XData.Web.Dataset,
  XData.Web.Client,
  WEBLib.DB,
  Vcl.Controls,
  WEBLib.Grids,
  WEBLib.DBCtrls,
  Vcl.StdCtrls,
  WEBLib.StdCtrls,
  Essentials.Web.Shared;

type
  { TODO :
  This could be further enhanced to allow notes to be made on new records and then saved once they have had an
  EntityId attached }
  TEssentialsNotesForm = class(TCoreWebForm)
    NotesDataset: TXDataWebDataSet;
    NotesDatasetId: TIntegerField;
    NotesDatasetDateAdded: TDateTimeField;
    NotesDatasetAddedBy: TIntegerField;
    NotesDatasetLastUpdatedBy: TIntegerField;
    NotesDatasetLastUpdated: TDateTimeField;
    NotesDatasetEntityClassName: TStringField;
    NotesDatasetEntityId: TIntegerField;
    NotesDatasetTitle: TStringField;
    NotesDatasetNoteFormat: TStringField;
    EssentialsNotesTable: TDBTableControl;
    NotesSource: TDataSource;
    NotesAddButton: TButton;
    NotesCancelButton: TButton;
    NotesSaveButton: TButton;
    NotesTitleEdit: TDBEdit;
    NoteData: TMemo;
    NotesDatasetNote: TMemoField;
    NotesEditButton: TButton;
    procedure EssentialsNotesTableClickCell(Sender: TObject; ACol, ARow: Integer);
    procedure NotesAddButtonClick(Sender: TObject);
    procedure NotesCancelButtonClick(Sender: TObject);
    procedure NotesDatasetAfterPost(DataSet: TDataSet);
    procedure NotesDatasetNewRecord(DataSet: TDataSet);
    procedure NotesSaveButtonClick(Sender: TObject);
    procedure NotesSourceStateChange(Sender: TObject);
    procedure WebFormCloseQuery(Sender: TObject; var CanClose: Boolean);
    procedure WebFormCreate(Sender: TObject);
    procedure NotesEditButtonClick(Sender: TObject);
  private
    FEntityClassName: string;
    FEntityId: Integer;
    FIsSaving: boolean;
    FIsClosing: Boolean;
    FIsLoadingNote: Boolean;
    FEditMode: TEditMode;
    { Private declarations }
    [Async]
    procedure LoadNotes; async;
    [Async]
    procedure LoadNoteData; async;
    procedure SetEntityId(const Value: Integer);
    procedure SetEntityName(const Value: string);
    [Async]
    procedure SaveNote; async;
    [Async]
    procedure SaveNoteData; async;
    procedure SetEditMode(Value: TEditMode);
    procedure UpdateButtonStates;
    function GetToggleMode(Value: TEditMode): TEditMode;
  public
    { Public declarations }
    property EntityClassName: string read FEntityClassName write SetEntityName;
    property EntityId: Integer read FEntityId write SetEntityId;
  protected procedure LoadDFMValues; override; end;

var
  EssentialsNotesForm: TEssentialsNotesForm;

implementation

{$R *.dfm}

uses
  SMX.Web.Utils,
  XData.Dataset.Utils,
  //ConnectionModule,
  Essentials.Shared,
  SMX.XDataSvc.Utils;

procedure TEssentialsNotesForm.EssentialsNotesTableClickCell(Sender: TObject;
  ACol, ARow: Integer);
var
  NoteId: Integer;
begin
  NoteId := EssentialsNotesTable.Cells[0, ARow].ToInteger;
  if NotesDatasetId.Value <> NoteId then
  begin
    NotesDataset.Locate('Id', NoteId, []);
    if NotesDatasetNote.IsNull then
      LoadNoteData
    else
      NoteData.Lines.Text := NotesDatasetNote.AsString;
  end;
end;

procedure TEssentialsNotesForm.WebFormCreate(Sender: TObject);
begin
  inherited;
  FIsSaving := False;
  FIsClosing := False;
  FIsLoadingNote := False;

  NotesDataset.Connection := EssentialsManager.WebClient.Connection;
  SetEditMode(None);
end;

{ TEssentialsNotesForm }

function TEssentialsNotesForm.GetToggleMode(Value: TEditMode): TEditMode;
begin
  Result := Essentials.Web.Shared.GetToggleMode(Value, FEditMode);
end;

procedure TEssentialsNotesForm.LoadNoteData; {$IFDEF PAS2JS}async;{$ENDIF}
var
  lNote: string;
  Data: TJSObject;

begin

  if FIsLoadingNote then
    Exit;

  if (not NotesDataset.Active) or NotesDataset.IsEmpty then
    Exit;

  // Only fetch if missing (lazy text)
//  if not NotesDatasetNote.IsNull then
//    Exit;

  FIsLoadingNote := True;
  try
    lNote := Await(EssentialsManager.NotesManager.GetNoteData(NotesDatasetId.Value));
    NoteData.Lines.Text := lNote;
    Data := TJSObject(NotesDataset.CurrentData);
    Data['Note'] := lNote;
  finally
    FIsLoadingNote := False;
  end;

end;

procedure TEssentialsNotesForm.LoadNotes; {$IFDEF PAS2JS}async;{$ENDIF}
var
  lQuery: string;
begin
  if (FEntityId = 0) or FEntityClassName.IsEmpty then
    Exit;

  //Don't bother if we have already opened
  if NotesDataset.Active then
    Exit;
  lQuery := '$filter=EntityClassName eq ' + FEntityClassName.QuotedString + ' and EntityId eq ' + FEntityId.ToString;
  lQuery := lQuery + '&$orderby=DateAdded desc';
  NotesDataset.QueryString := lQuery;
  Await(NotesDataset.LoadAsync);
  if not NotesDataset.IsEmpty then
    LoadNoteData;
end;

procedure TEssentialsNotesForm.NotesAddButtonClick(Sender: TObject);
begin
  SetEditMode(GetToggleMode(Add));

  if FEditMode = Add then
  begin
    NotesDataset.Insert;
    NoteData.Lines.Clear;
  end;
end;

procedure TEssentialsNotesForm.NotesCancelButtonClick(Sender: TObject);
begin
  NotesDataset.Cancel;
  SetEditMode(None);
end;

procedure TEssentialsNotesForm.NotesDatasetAfterPost(DataSet: TDataSet);
begin
  if not FIsSaving then
    SaveNote;
end;

procedure TEssentialsNotesForm.NotesDatasetNewRecord(DataSet: TDataSet);
begin
  NotesDatasetDateAdded.Value := Now;
  NotesDatasetLastUpdated.Value := Now;
  NotesDatasetEntityClassName.Value := FEntityClassName;
  NotesDatasetEntityId.Value := FEntityId;
end;

procedure TEssentialsNotesForm.NotesSaveButtonClick(Sender: TObject);
begin
  SaveNote;
  SetEditMode(None);
end;

procedure TEssentialsNotesForm.NotesSourceStateChange(Sender: TObject);
begin
  UpdateButtonStates;
end;

procedure TEssentialsNotesForm.SaveNote; {$IFDEF PAS2JS}async;{$ENDIF}
var
  Info: TResolveResults;
begin
  FIsSaving := True;
  try
    if TXDataDSUtils.CheckIsModified(NotesDataset) then
    begin
      Info := Await(NotesDataset.ApplyUpdatesAsync);
      if (Info.Records[0].Status = TUpdateStatus.usInserted) then
        TXDataDSUtils.UpdateId(NotesDataset, Info, 'Id', 0);

    end;

    Await(SaveNoteData);

  finally
    FIsSaving := False;
  end;

  if FIsClosing then
    Self.Close;
end;

procedure TEssentialsNotesForm.SaveNoteData; {$IFDEF PAS2JS}async;{$ENDIF}
var
  lNote: string;
  Data: TJSObject;
begin

  lNote := Await(EssentialsManager.NotesManager.SaveNoteData(NotesDatasetId.Value,
    NoteData.Lines.Text));
  if lNote = 'OK' then
  begin
    Data := TJSObject(NotesDataset.CurrentData);
    Data['Note'] := NoteData.Lines.Text;
  end;

end;

procedure TEssentialsNotesForm.SetEditMode(Value: TEditMode);
begin
  if FEditMode = Value then
    Exit;

  if (FEditMode <> None) and (NotesSource.State in dsEditModes) then
    NotesDataset.Cancel;

  FEditMode := Value;

  if FEditMode <> None then
  begin
    NotesDataset.Edit;
    NotesTitleEdit.SetFocus;
  end;

  UpdateButtonStates;
end;

procedure TEssentialsNotesForm.SetEntityId(const Value: Integer);
begin
  if (FEntityId = Value) then
    Exit;

  if (FEntityId > 0) and (FEntityId <> Value) and NotesDataset.Active then
    { TODO : check to see if any data needs saving }
    NotesDataset.Close;

  FEntityId := Value;
  LoadNotes;
end;

procedure TEssentialsNotesForm.SetEntityName(const Value: string);
begin
  if FEntityClassName = Value then
    Exit;

  FEntityClassName := Value;
  LoadNotes;
end;

procedure TEssentialsNotesForm.UpdateButtonStates;
begin
  NotesSaveButton.Enabled := FEditMode <> None;
  NotesCancelButton.Enabled := NotesSaveButton.Enabled;
  NotesAddButton.Enabled := (FEditMode = None) and (FEntityId > 0);
  NotesEditButton.Enabled := NotesAddButton.Enabled;
end;

procedure TEssentialsNotesForm.NotesEditButtonClick(Sender: TObject);
begin
  inherited;
  SetEditMode(GetToggleMode(Edit));
end;

procedure TEssentialsNotesForm.WebFormCloseQuery(Sender: TObject; var CanClose:
  Boolean);
begin
  inherited;
  if TXDataDSUtils.CheckIsModified(NotesDataset) then
  begin
    FIsClosing := True;
    SaveNote;
  end
  else
    CanClose := True;
end;

procedure TEssentialsNotesForm.LoadDFMValues;
begin
  inherited LoadDFMValues;

  EssentialsNotesTable := TDBTableControl.Create('essentials.notes.table');
  NotesAddButton := TButton.Create('essentials.notes.add.button');
  NotesCancelButton := TButton.Create('essentials.notes.cancel.button');
  NotesSaveButton := TButton.Create('essentials.notes.save.button');
  NotesTitleEdit := TDBEdit.Create('essentials.note.title.edit');
  NoteData := TMemo.Create('essentails.note.note');
  NotesEditButton := TButton.Create('essentials.notes.edit.button');
  NotesDataset := TXDataWebDataSet.Create(Self);
  NotesDatasetId := TIntegerField.Create(Self);
  NotesDatasetDateAdded := TDateTimeField.Create(Self);
  NotesDatasetAddedBy := TIntegerField.Create(Self);
  NotesDatasetLastUpdatedBy := TIntegerField.Create(Self);
  NotesDatasetLastUpdated := TDateTimeField.Create(Self);
  NotesDatasetEntityClassName := TStringField.Create(Self);
  NotesDatasetEntityId := TIntegerField.Create(Self);
  NotesDatasetTitle := TStringField.Create(Self);
  NotesDatasetNoteFormat := TStringField.Create(Self);
  NotesDatasetNote := TMemoField.Create(Self);
  NotesSource := TDataSource.Create(Self);

  EssentialsNotesTable.BeforeLoadDFMValues;
  NotesAddButton.BeforeLoadDFMValues;
  NotesCancelButton.BeforeLoadDFMValues;
  NotesSaveButton.BeforeLoadDFMValues;
  NotesTitleEdit.BeforeLoadDFMValues;
  NoteData.BeforeLoadDFMValues;
  NotesEditButton.BeforeLoadDFMValues;
  NotesDataset.BeforeLoadDFMValues;
  NotesDatasetId.BeforeLoadDFMValues;
  NotesDatasetDateAdded.BeforeLoadDFMValues;
  NotesDatasetAddedBy.BeforeLoadDFMValues;
  NotesDatasetLastUpdatedBy.BeforeLoadDFMValues;
  NotesDatasetLastUpdated.BeforeLoadDFMValues;
  NotesDatasetEntityClassName.BeforeLoadDFMValues;
  NotesDatasetEntityId.BeforeLoadDFMValues;
  NotesDatasetTitle.BeforeLoadDFMValues;
  NotesDatasetNoteFormat.BeforeLoadDFMValues;
  NotesDatasetNote.BeforeLoadDFMValues;
  NotesSource.BeforeLoadDFMValues;
  try
    Height := 647;
    SetEvent(Self, 'OnCloseQuery', 'WebFormCloseQuery');
    SetEvent(Self, 'OnCreate', 'WebFormCreate');
    EssentialsNotesTable.SetParentComponent(Self);
    EssentialsNotesTable.Name := 'EssentialsNotesTable';
    EssentialsNotesTable.Left := 128;
    EssentialsNotesTable.Top := 40;
    EssentialsNotesTable.Width := 425;
    EssentialsNotesTable.Height := 257;
    EssentialsNotesTable.HeightStyle := ssAuto;
    EssentialsNotesTable.WidthStyle := ssAuto;
    EssentialsNotesTable.BorderColor := clSilver;
    EssentialsNotesTable.ElementFont := efCSS;
    EssentialsNotesTable.ElementHeaderClassName := 'thead-light';
    EssentialsNotesTable.ElementPosition := epIgnore;
    EssentialsNotesTable.ElementTableClassName := 'table table-striped table-bordered  table-hover';
    EssentialsNotesTable.Footer.ButtonActiveElementClassName := 'btn btn-primary';
    EssentialsNotesTable.Footer.ButtonElementClassName := 'btn btn-light';
    EssentialsNotesTable.Footer.DropDownElementClassName := 'form-control';
    EssentialsNotesTable.Footer.InputElementClassName := 'form-control';
    EssentialsNotesTable.Footer.LinkActiveElementClassName := 'link-primary';
    EssentialsNotesTable.Footer.LinkElementClassName := 'link-secondary';
    EssentialsNotesTable.Footer.ListElementClassName := 'pagination';
    EssentialsNotesTable.Footer.ListItemElementClassName := 'page-item';
    EssentialsNotesTable.Footer.ListLinkElementClassName := 'page-link';
    EssentialsNotesTable.Header.ButtonActiveElementClassName := 'btn btn-primary';
    EssentialsNotesTable.Header.ButtonElementClassName := 'btn btn-light';
    EssentialsNotesTable.Header.DropDownElementClassName := 'form-control';
    EssentialsNotesTable.Header.InputElementClassName := 'form-control';
    EssentialsNotesTable.Header.LinkActiveElementClassName := 'link-primary';
    EssentialsNotesTable.Header.LinkElementClassName := 'link-secondary';
    EssentialsNotesTable.Header.ListElementClassName := 'pagination';
    EssentialsNotesTable.Header.ListItemElementClassName := 'page-item';
    EssentialsNotesTable.Header.ListLinkElementClassName := 'page-link';
    SetEvent(EssentialsNotesTable, Self, 'OnClickCell', 'EssentialsNotesTableClickCell');
    EssentialsNotesTable.Columns.Clear;
    with EssentialsNotesTable.Columns.Add do
    begin
      DataField := 'Id';
      Title := 'Id';
    end;
    with EssentialsNotesTable.Columns.Add do
    begin
      DataField := 'Title';
      Title := 'Title';
    end;
    with EssentialsNotesTable.Columns.Add do
    begin
      DataField := 'DateAdded';
      Title := 'DateAdded';
    end;
    with EssentialsNotesTable.Columns.Add do
    begin
      DataField := 'LastUpdated';
      Title := 'Updated';
    end;
    EssentialsNotesTable.DataSource := NotesSource;
    NotesAddButton.SetParentComponent(Self);
    NotesAddButton.Name := 'NotesAddButton';
    NotesAddButton.Left := 127;
    NotesAddButton.Top := 576;
    NotesAddButton.Width := 96;
    NotesAddButton.Height := 25;
    NotesAddButton.Caption := 'Add';
    NotesAddButton.ChildOrder := 7;
    NotesAddButton.ElementClassName := 'btn btn-light';
    NotesAddButton.ElementFont := efCSS;
    NotesAddButton.ElementPosition := epIgnore;
    NotesAddButton.HeightStyle := ssAuto;
    NotesAddButton.HeightPercent := 100.000000000000000000;
    NotesAddButton.WidthStyle := ssAuto;
    NotesAddButton.WidthPercent := 100.000000000000000000;
    SetEvent(NotesAddButton, Self, 'OnClick', 'NotesAddButtonClick');
    NotesCancelButton.SetParentComponent(Self);
    NotesCancelButton.Name := 'NotesCancelButton';
    NotesCancelButton.Left := 346;
    NotesCancelButton.Top := 576;
    NotesCancelButton.Width := 96;
    NotesCancelButton.Height := 25;
    NotesCancelButton.Caption := 'Cancel';
    NotesCancelButton.ChildOrder := 7;
    NotesCancelButton.ElementClassName := 'btn btn-light';
    NotesCancelButton.ElementFont := efCSS;
    NotesCancelButton.ElementPosition := epIgnore;
    NotesCancelButton.HeightStyle := ssAuto;
    NotesCancelButton.HeightPercent := 100.000000000000000000;
    NotesCancelButton.WidthStyle := ssAuto;
    NotesCancelButton.WidthPercent := 100.000000000000000000;
    SetEvent(NotesCancelButton, Self, 'OnClick', 'NotesCancelButtonClick');
    NotesSaveButton.SetParentComponent(Self);
    NotesSaveButton.Name := 'NotesSaveButton';
    NotesSaveButton.Left := 457;
    NotesSaveButton.Top := 576;
    NotesSaveButton.Width := 96;
    NotesSaveButton.Height := 25;
    NotesSaveButton.Caption := 'Save';
    NotesSaveButton.ChildOrder := 7;
    NotesSaveButton.ElementClassName := 'btn btn-light';
    NotesSaveButton.ElementFont := efCSS;
    NotesSaveButton.ElementPosition := epIgnore;
    NotesSaveButton.HeightStyle := ssAuto;
    NotesSaveButton.HeightPercent := 100.000000000000000000;
    NotesSaveButton.WidthStyle := ssAuto;
    NotesSaveButton.WidthPercent := 100.000000000000000000;
    SetEvent(NotesSaveButton, Self, 'OnClick', 'NotesSaveButtonClick');
    NotesTitleEdit.SetParentComponent(Self);
    NotesTitleEdit.Name := 'NotesTitleEdit';
    NotesTitleEdit.Left := 127;
    NotesTitleEdit.Top := 368;
    NotesTitleEdit.Width := 426;
    NotesTitleEdit.Height := 22;
    NotesTitleEdit.ChildOrder := 4;
    NotesTitleEdit.ElementClassName := 'form-control';
    NotesTitleEdit.ElementFont := efCSS;
    NotesTitleEdit.ElementPosition := epIgnore;
    NotesTitleEdit.HeightStyle := ssAuto;
    NotesTitleEdit.HeightPercent := 100.000000000000000000;
    NotesTitleEdit.Text := 'NotesTitleEdit';
    NotesTitleEdit.WidthStyle := ssAuto;
    NotesTitleEdit.WidthPercent := 100.000000000000000000;
    NotesTitleEdit.DataField := 'Title';
    NotesTitleEdit.DataSource := NotesSource;
    NoteData.SetParentComponent(Self);
    NoteData.Name := 'NoteData';
    NoteData.Left := 128;
    NoteData.Top := 424;
    NoteData.Width := 425;
    NoteData.Height := 129;
    NoteData.ElementClassName := 'form-control';
    NoteData.ElementFont := efCSS;
    NoteData.HeightPercent := 100.000000000000000000;
    NoteData.SelLength := 0;
    NoteData.SelStart := 0;
    NoteData.WidthPercent := 100.000000000000000000;
    NotesEditButton.SetParentComponent(Self);
    NotesEditButton.Name := 'NotesEditButton';
    NotesEditButton.Left := 229;
    NotesEditButton.Top := 576;
    NotesEditButton.Width := 96;
    NotesEditButton.Height := 25;
    NotesEditButton.Caption := 'Edit';
    NotesEditButton.ChildOrder := 7;
    NotesEditButton.ElementClassName := 'btn btn-light';
    NotesEditButton.ElementFont := efCSS;
    NotesEditButton.ElementPosition := epIgnore;
    NotesEditButton.HeightStyle := ssAuto;
    NotesEditButton.HeightPercent := 100.000000000000000000;
    NotesEditButton.WidthStyle := ssAuto;
    NotesEditButton.WidthPercent := 100.000000000000000000;
    SetEvent(NotesEditButton, Self, 'OnClick', 'NotesEditButtonClick');
    NotesDataset.SetParentComponent(Self);
    NotesDataset.Name := 'NotesDataset';
    NotesDataset.AfterPost := NotesDatasetAfterPost;
    SetEvent(NotesDataset, Self, 'OnNewRecord', 'NotesDatasetNewRecord');
    NotesDataset.EntitySetName := 'sxeNote';
    NotesDataset.Left := 64;
    NotesDataset.Top := 72;
    NotesDatasetId.SetParentComponent(NotesDataset);
    NotesDatasetId.Name := 'NotesDatasetId';
    NotesDatasetId.FieldName := 'Id';
    NotesDatasetDateAdded.SetParentComponent(NotesDataset);
    NotesDatasetDateAdded.Name := 'NotesDatasetDateAdded';
    NotesDatasetDateAdded.FieldName := 'DateAdded';
    NotesDatasetAddedBy.SetParentComponent(NotesDataset);
    NotesDatasetAddedBy.Name := 'NotesDatasetAddedBy';
    NotesDatasetAddedBy.FieldName := 'AddedBy';
    NotesDatasetLastUpdatedBy.SetParentComponent(NotesDataset);
    NotesDatasetLastUpdatedBy.Name := 'NotesDatasetLastUpdatedBy';
    NotesDatasetLastUpdatedBy.FieldName := 'LastUpdatedBy';
    NotesDatasetLastUpdated.SetParentComponent(NotesDataset);
    NotesDatasetLastUpdated.Name := 'NotesDatasetLastUpdated';
    NotesDatasetLastUpdated.FieldName := 'LastUpdated';
    NotesDatasetEntityClassName.SetParentComponent(NotesDataset);
    NotesDatasetEntityClassName.Name := 'NotesDatasetEntityClassName';
    NotesDatasetEntityClassName.FieldName := 'EntityClassName';
    NotesDatasetEntityClassName.Size := 64;
    NotesDatasetEntityId.SetParentComponent(NotesDataset);
    NotesDatasetEntityId.Name := 'NotesDatasetEntityId';
    NotesDatasetEntityId.FieldName := 'EntityId';
    NotesDatasetTitle.SetParentComponent(NotesDataset);
    NotesDatasetTitle.Name := 'NotesDatasetTitle';
    NotesDatasetTitle.FieldName := 'Title';
    NotesDatasetTitle.Size := 255;
    NotesDatasetNoteFormat.SetParentComponent(NotesDataset);
    NotesDatasetNoteFormat.Name := 'NotesDatasetNoteFormat';
    NotesDatasetNoteFormat.FieldName := 'NoteFormat';
    NotesDatasetNoteFormat.Size := 9;
    NotesDatasetNote.SetParentComponent(NotesDataset);
    NotesDatasetNote.Name := 'NotesDatasetNote';
    NotesDatasetNote.FieldName := 'Note';
    NotesDatasetNote.BlobType := ftMemo;
    NotesSource.SetParentComponent(Self);
    NotesSource.Name := 'NotesSource';
    NotesSource.AutoEdit := False;
    NotesSource.DataSet := NotesDataset;
    SetEvent(NotesSource, Self, 'OnStateChange', 'NotesSourceStateChange');
    NotesSource.Left := 64;
    NotesSource.Top := 144;
  finally
    EssentialsNotesTable.AfterLoadDFMValues;
    NotesAddButton.AfterLoadDFMValues;
    NotesCancelButton.AfterLoadDFMValues;
    NotesSaveButton.AfterLoadDFMValues;
    NotesTitleEdit.AfterLoadDFMValues;
    NoteData.AfterLoadDFMValues;
    NotesEditButton.AfterLoadDFMValues;
    NotesDataset.AfterLoadDFMValues;
    NotesDatasetId.AfterLoadDFMValues;
    NotesDatasetDateAdded.AfterLoadDFMValues;
    NotesDatasetAddedBy.AfterLoadDFMValues;
    NotesDatasetLastUpdatedBy.AfterLoadDFMValues;
    NotesDatasetLastUpdated.AfterLoadDFMValues;
    NotesDatasetEntityClassName.AfterLoadDFMValues;
    NotesDatasetEntityId.AfterLoadDFMValues;
    NotesDatasetTitle.AfterLoadDFMValues;
    NotesDatasetNoteFormat.AfterLoadDFMValues;
    NotesDatasetNote.AfterLoadDFMValues;
    NotesSource.AfterLoadDFMValues;
  end;
end;

end.

